import { Component, computed, inject, input, model, signal } from '@angular/core';
import { ActivatedRoute, ActivatedRouteSnapshot, ResolveFn, Router, RouterStateSnapshot } from '@angular/router';
import { UsuarioCouchBase } from '../../../model/usuario';
import { DhrQuarkusService } from '../../../services/dhr.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { JsonPipe } from '@angular/common';
import { AbstractComponent } from '../../../abstract-component';

export const userResolver: ResolveFn<UsuarioCouchBase|null> = async (route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const dhrService = inject(DhrQuarkusService);
  let retorno: UsuarioCouchBase | null = null;
  const id = route.queryParamMap.get('id');
  console.log(`userResolver(${id})`);

  if (id != null){
    retorno = await dhrService.getUserCouchBase(Number(id));
  }
  return retorno;
};

@Component({
  selector: 'app-angular-test-tio-angular',
  imports: [JsonPipe],
  templateUrl: './angular-test-tio-angular.component.html',
  styleUrl: './angular-test-tio-angular.component.css'
})
export class AngularTestTioAngularComponent extends AbstractComponent {
  private activatedRoute = inject(ActivatedRoute)
  // asi cojo el id de usuario
  id = signal(0);
  usuarioPorPath: UsuarioCouchBase | null = null;
  protected usuarioSignal = signal(null as UsuarioCouchBase | null);

  // y con resolver
  private data = toSignal(this.activatedRoute.data, {initialValue: undefined});
  // OJO PARA QUE FUNCIONE CON INPUT, EL NOMBRE DEL INPUT DEBE SER IGUAL AL NOMBRE DEL RESOLVER
  protected usuario = input.required<UsuarioCouchBase|null>();
  // AQUI NO HACE FALTA QUE EL NOMBRE DEL INPUT COMPUTED SEA IGUAL AL NOMBRE DEL RESOLVER PUES SE ESPECIFICA DESPUES
  protected usuarioResolverComputed = computed(() => {
    const data = this.data();
    if (data && data['usuario']) {
      return data['usuario'] as UsuarioCouchBase;
    }
    return null;
  });

  constructor(private router: Router) {
    super()
    console.log(`AngularTestTioAngularComponent:: constructor()`);
    this.activatedRoute.params
      .subscribe(async(params) => {
        const id = params['id'];
        console.log(`***** AngularTestTioAngularComponent cambio de id id: ${id}. Estableciendo id: ${this.id()}`);
        
        this.usuarioSignal.set(await this.dhrService.getUserCouchBase(Number(id)));
        
        this.id.set(id);
      });
    console.log(`AngularTestTioAngularComponent:: constructor() id: ${this.id()}`);
  } 
  
  
  protected usuarioBean = this.data() as UsuarioCouchBase | null;

}
